import type { SiteShell } from "../../server/shell";

/** The League Bible always sets Inter, which a site with its own body face doesn't preload. */
export function bibleHead<T extends { links?: object[] }>(head: T, shell: SiteShell) {
  return shell.fonts.body
    ? {
        ...head,
        links: [
          ...(head.links ?? []),
          {
            rel: "preload",
            href: "/_app/fonts/inter-variable.woff2",
            as: "font",
            type: "font/woff2",
            crossOrigin: "anonymous" as const,
          },
        ],
      }
    : head;
}
